export class StreamCursorHalt {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "topicPartition",
            "baseName": "topicPartition",
            "type": "KafkaTopicPartition",
            "format": ""
        },
        {
            "name": "lostFrom",
            "baseName": "lostFrom",
            "type": "string",
            "format": ""
        },
        {
            "name": "logStart",
            "baseName": "logStart",
            "type": "string",
            "format": ""
        },
        {
            "name": "logEnd",
            "baseName": "logEnd",
            "type": "string",
            "format": ""
        },
        {
            "name": "sinceMs",
            "baseName": "sinceMs",
            "type": "number",
            "format": ""
        },
        {
            "name": "generation",
            "baseName": "generation",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StreamCursorHalt.attributeTypeMap;
    }
    constructor() {
    }
}
